import * as React from "react";
import type { SVGProps } from "react";
const SvgAllLogo = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={40}
    height={24}
    viewBox="0 0 40 24"
    {...props}
  >
    <g clipPath="url(#ALL-logo_svg__a)">
      <path d="M22.472 23.99h-5.55l-4.082-8.794c-1.25.674-2.199 1.844-3.19 3.065-.775.956-1.576 1.943-2.567 2.75-1.154.938-2.495 1.768-4.17 2.335-.76.254-2.051.586-2.534.635-.207.02-.345.01-.375-.058-.02-.059.03-.098.246-.206.044-.02.113-.05.199-.09.398-.177 1.178-.525 1.704-.887.799-.557 1.252-1.153 1.292-1.612-.04-.142-.127-.315-.232-.524-.458-.918-1.256-2.517.044-5.056.23-.452.447-.851.648-1.22.298-.55.56-1.031.772-1.516.404-.929.7-2.238.799-3.216.01-.058.02-.058.049-.02.779.783 3.796 3.851 3.352 6.91 1.006-.381 2.74-1.544 3.54-2.16q.279-.219.526-.43c.582-.49 1.072-.903 1.77-.918.45-.006.668.112.887.23.17.093.341.185.622.22.158.019.394-.01.512-.07.05-.019.04-.077-.039-.097-.36-.085-.61-.257-.857-.428-.348-.24-.695-.48-1.351-.48-.757 0-1.402.52-1.923.939-.171.138-.329.266-.473.36l-2.85-5.883C8.06 5.306 8.415 3.518 11.037 0zM31.532 24h-3.44c-1.45 0-2.19-.318-2.722-1.023-.571-.744-.571-1.886-.571-2.959V.01h4.436v20.654c0 1.638.178 2.8 2.297 3.266zM36.56 24H40v-.07c-2.12-.466-2.297-1.628-2.297-3.266V.01h-4.437v20.008c0 1.073 0 2.215.572 2.96.533.704 1.272 1.022 2.721 1.022" />
    </g>
    <defs>
      <clipPath id="ALL-logo_svg__a">
        <path fill="#fff" d="M0 0h40v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgAllLogo;
